import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=36e8fb07&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=36e8fb07&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e8fb07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36e8fb07')) {
      api.createRecord('36e8fb07', component.options)
    } else {
      api.reload('36e8fb07', component.options)
    }
    module.hot.accept("./upload.vue?vue&type=template&id=36e8fb07&scoped=true", function () {
      api.rerender('36e8fb07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/supersubsidy/marketingEvents/component/upload.vue"
export default component.exports